import { render, staticRenderFns } from "./InfoQuestionary.vue?vue&type=template&id=ff6218cc&scoped=true&"
import script from "./InfoQuestionary.vue?vue&type=script&lang=ts&"
export * from "./InfoQuestionary.vue?vue&type=script&lang=ts&"
import style0 from "./InfoQuestionary.vue?vue&type=style&index=0&id=ff6218cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6218cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
